// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1i_Ir","title":"AfterImages45_title__27ewj","images":"AfterImages45_images__1Ui-t"};